import React from 'react';
import { useTranslation } from 'react-i18next';
import { CategoryModalProps } from '../BusinessPage.types';
import * as S from './BusinessPageFormCategorySelect.styles';
import useScreenSize from '@/hooks/useScreenSize';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

export const CategorySelect: React.FC<CategoryModalProps> = ({
  categories,
  selectedCategories,
  showCategoryModal,
  modalEl,
  onChange,
  onClose,
}) => {
  const { t } = useTranslation();
  const { isMedium, isLarge } = useScreenSize();

  return (
    <>
      {isLarge ? (
        <S.BusinessPageFormModal ref={modalEl} $showModal={showCategoryModal}>
          {categories.map(item => (
            <S.BusinessPageFormCategoryLabel
              key={item.id}
              $checked={selectedCategories.includes(item.id)}
            >
              <S.BusinessPageFormCategoryInput
                id={item.id}
                type="checkbox"
                name="categories"
                onChange={onChange}
                value={item.name}
              />
              <S.BusinessPageFormCategoryCheckbox
                $checked={selectedCategories.includes(item.id)}
              />
              {item.name}
            </S.BusinessPageFormCategoryLabel>
          ))}
        </S.BusinessPageFormModal>
      ) : (
        <BottomSheet
          isPageLocked
          isOpen={showCategoryModal}
          close={() => onClose}
        >
          <>
            <S.ModalContent>
              {t('business.form.category')}
              <S.ModalCloseButton
                $categoryModal={isMedium}
                onClick={onClose}
                data-testid="business-category-close"
              />
            </S.ModalContent>
            <S.BusinessPageFormCategoryModal>
              {categories.map(item => (
                <S.BusinessPageFormCategoryLabel
                  data-testid="business-category-id"
                  key={item.id}
                  $checked={selectedCategories.includes(item.id)}
                  $categoryModal={isMedium}
                >
                  <S.BusinessPageFormCategoryImage>
                    <img
                      src={item.icon}
                      alt=""
                      width={26}
                      height={26}
                      loading="lazy"
                    />
                  </S.BusinessPageFormCategoryImage>
                  <S.BusinessPageFormCategoryInput
                    id={item.id}
                    type="checkbox"
                    name="categories"
                    onChange={onChange}
                    value={item.name}
                  />
                  <S.BusinessPageFormCategoryCheckbox
                    $checked={selectedCategories.includes(item.id)}
                    $categoryModal={isMedium}
                  />
                  {item.name}
                </S.BusinessPageFormCategoryLabel>
              ))}
            </S.BusinessPageFormCategoryModal>
            <S.BusinessPageFormCategoryButton onClick={onClose}>
              {t('business.form.btn_ready')}
            </S.BusinessPageFormCategoryButton>
          </>
        </BottomSheet>
      )}
    </>
  );
};
